export const saveOtherGroupSkills = ({ group, skills }) => {
  return {
    type: 'SAVE_OTHER_GROUP_SKILLS',
    group,
    skills,
  };
};
